<template>
  <v-container class="pa-6" v-if="profile">
    <div style="margin-bottom: 24px">
      <div class="component-title">Thông tin ticket</div>
      <v-breadcrumbs class="pa-0 ma-0" :items="items">
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
      </v-breadcrumbs>
    </div>
    <TicketInfo :profile="profile" @refresh="getProfileData" />
    <v-card style="margin-bottom: 24px" outlined>
      <div class="d-flex justify-space-between align-items-center px-6 pt-6">
        <h5 class="text-uppercase align-self-center">Trạng thái ticket</h5>
      </div>
      <v-stepper v-model="currentStep" non-linear alt-labels class="stepper elevation-0">
        <v-stepper-header>
          <v-stepper-step
            class="py-6 clickable-step"
            :complete="isStepComplete(1)"
            step="1"
            @click="handleStepClick(1)"
          >
            Chưa hỗ trợ
            <template v-if="currentStep === 1 && profile.subStatus">
              <div class="step-subtitle">{{ `(${profile.subStatus})` }}</div>
            </template>
          </v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step
            class="py-6 clickable-step"
            :complete="isStepComplete(2)"
            step="2"
            @click="handleStepClick(2)"
          >
            Đang hỗ trợ
            <template v-if="currentStep === 2 && profile.subStatus">
              <div class="step-subtitle">{{ `(${profile.subStatus})` }}</div>
            </template>
          </v-stepper-step>

          <v-divider></v-divider>
          <v-stepper-step
            class="py-6 clickable-step"
            :complete="isStepComplete(3)"
            step="3"
            @click="handleStepClick(3)"
          >
            Đã hỗ trợ
            <template v-if="currentStep === 3 && profile.subStatus">
              <div class="step-subtitle">{{ `(${profile.subStatus})` }}</div>
            </template>
          </v-stepper-step>
        </v-stepper-header>
      </v-stepper>
      <div class="px-6 pb-6">
        <span style="color: red">*</span>
        <span style="color: grey; font-size: smaller">
          Xin vui lòng bấm vào một bước trên để thay đổi trạng thái ticket</span
        >
      </div>
    </v-card>
    <v-row>
      <v-col cols="6">
        <StudentTicketMessages :messages="messages" @refresh="refresh" />
      </v-col>
      <v-col cols="6">
        <StudentTicketNote :notes="profile.notes || []" @refresh="refresh" />
      </v-col>
    </v-row>
    <v-card outlined>
      <div class="d-flex justify-space-between align-items-center px-6 py-6">
        <h5 class="text-uppercase align-self-center grey--text">Lịch sử hỗ trợ</h5>
      </div>
      <TicketLog :items="sortedLogs" />
    </v-card>
    <TicketProgressStep
      :dialog="doingDialog"
      @inputConfirmed="processDoing"
      @closeDialog="closeDoing"
      :profile="profile"
    />
    <TicketFinishStep :dialog="finishDialog" @inputConfirmed="processFinish" @closeDialog="closeFinish" />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import StudentTicketMessages from '../../modules/studentTicket/StudentTicketMessages.vue'
import TicketInfo from '../../modules/studentTicket/TicketInfo.vue'
import TicketLog from '../../modules/studentTicket/TicketLog.vue'
import TicketProgressStep from '../../modules/studentTicket/TicketProgressStep.vue'
import TicketFinishStep from '../../modules/studentTicket/TicketFinishStep.vue'
import StudentTicketNote from '../../modules/studentTicket/StudentTicketNote.vue'
export default {
  components: { TicketInfo, TicketLog, StudentTicketMessages, TicketProgressStep, TicketFinishStep, StudentTicketNote },
  data() {
    return {
      profile: {},
      sortedLogs: [],
      messages: [],
      showAppointment: false,
      showProduct: false,
      showMenu: false,
      doingDialog: false,
      finishDialog: false,
      productsList: [],
      users: [],
      items: [
        {
          text: 'Các ticket',
          disabled: false,
          href: '/student-tickets'
        },
        {
          text: 'Thông tin ticket',
          disabled: false
        }
      ]
    }
  },

  mounted() {
    this.getProfileData()
  },
  computed: {
    ...mapGetters('auth', ['user']),

    currentStep() {
      switch (this.profile.status) {
        case 'notSeen':
          return 1
        case 'inProgress':
          return 2
        case 'closed':
          return 3
        default:
          return 0
      }
    }
  },
  methods: {
    ...mapActions('studentTickets', ['getOneStudentTicket', 'updateStudentTicket']),
    ...mapActions('ticketLog', ['fetchLogs']),
    ...mapActions('ticketMessage', ['fetchStudentTicketMessages']),

    async getProfileData() {
      this.$loading.active = true
      const id = this.$route.params.id
      try {
        const response = await this.getOneStudentTicket({ id })
        this.getLogs()
        this.getMessages()
        this.profile = response
      } catch (error) {
        console.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    isStepComplete(stepNumber) {
      return this.currentStep > stepNumber
    },
    handleStepClick(step) {
      switch (step) {
        case 1:
          return this.updateStatus('notSeen')
        case 2:
          return this.openDoing()
        case 3:
          return this.openFinish()
      }
    },
    async updateStatus(newStatus, data) {
      this.$loading.active = true
      try {
        let updateData = { ...data }
        if (!data) updateData.subStatus = null
        const updatedForm = await this.updateStudentTicket({ id: this.profile.id, status: newStatus, ...data })
        if (updatedForm) this.profile = updatedForm
        this.$alert.success('Đã cập nhập trạng thái thành công')
        this.getLogs()
        this.getMessages()
      } catch (error) {
        console.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    openDoing() {
      this.doingDialog = true
    },
    closeDoing() {
      this.doingDialog = false
    },
    async processDoing(data) {
      await this.updateStatus('inProgress', data)
      this.doingDialog = false
    },
    openFinish() {
      this.finishDialog = true
    },
    closeFinish() {
      this.finishDialog = false
    },
    async processFinish(data) {
      await this.updateStatus('closed', data)
      this.finishDialog = false
    },
    async refresh() {
      await this.getProfileData()
      this.$loading.active = false
    },
    setStatus(newStatus) {
      this.updateStatus(newStatus)
      this.showMenu = false
    },
    async getLogs() {
      const logs = await this.fetchLogs({ studentTicket: this.$route.params.id })
      if (Array.isArray(logs) && logs.length) {
        this.sortedLogs = logs.sort((a, b) => new Date(a.time) - new Date(b.time))
      }
    },
    async getMessages() {
      const messages = await this.fetchStudentTicketMessages({ ticket: this.$route.params.id })
      if (Array.isArray(messages) && messages.length) {
        this.messages = messages.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
      }
    }
  }
}
</script>

<style>
.stepper .v-stepper__label {
  text-align: center !important;
}

.clickable-step:hover {
  cursor: pointer;
}

.clickable-step:hover .v-stepper__label {
  color: #0d47a1 !important;
}

.button-background {
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 5px;
}
.return-btn {
  text-transform: lowercase !important;
  opacity: 1 !important;
}
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
.v-breadcrumbs__divider {
  padding: 0 !important;
}
.non-clickable-step {
  cursor: not-allowed !important;
}
.step-subtitle {
  font-size: 12px;
  margin-top: 8px;
  color: grey;
}
</style>
